import { getFunctions, httpsCallable } from 'firebase/functions';

/**
 * Republish `app/brand-search-index` on demand — the escape hatch from the daily rebuild schedule, so a
 * curation pass reaches the app's brand typeahead without waiting overnight. Server-side, `requireAdmin`
 * gates it. Returns how many brands made it into the published index.
 */
export async function rebuildBrandSearchIndexNow(): Promise<{ entryCount: number }> {
    const fn = httpsCallable<void, { entryCount: number }>(getFunctions(), 'rebuildBrandSearchIndexNow');
    const result = await fn();
    return result.data;
}
